// Copyright (c) 2022 by Move Closer

import { ApiConnectorType, AppModule, Container, IConfiguration, Interfaces, Module } from '@movecloser/front-core'

import { GraphQlConnectorType, IGraphQL } from '../../contexts'
import { COMPONENTS_STRUCTURE_CONFIG, logger } from '../../support'
import { ComponentsStructureConfig } from '../../support/mixins'

import { AuthGraphQLMiddlewareType } from '../auth/services'
import { IProfileTabsService, ProfileTabsServiceType } from '../profile/services/profile-tabs'

import { IOrdersRepository, OrdersRepositoryType } from './contracts/repository'
import { OrdersRepository } from './repositories/orders'
import { orderQueries } from './config/queries'
import { routesFactory as routes } from './routes'
import { pickTabItemsFactory } from '../shared/support/tabs.factory'
import { IOrderStatusesService, OrderStatusesServiceType, Service } from './services/order-statuses'
import { storeFactory as state } from './store'
import { TabOption } from '../shared/contracts/tabs'

/**
 * @author Katarzyna Otto <katarzyna.otto@movecloser.pl>
 * @author Filip Rurak <filip.rurak@movecloser.pl>
 */
@AppModule({
  name: 'orders',
  providers: () => (bind: Interfaces.Bind) => {
    bind<IOrderStatusesService>(OrderStatusesServiceType).toDynamicValue(() => {
      return new Service([])
    }).inSingletonScope()
    bind<IOrdersRepository>(OrdersRepositoryType).toDynamicValue((context) => {
      return new OrdersRepository(
        context.container.get(ApiConnectorType),
        context.container.get(GraphQlConnectorType)
      )
    })
  },
  boot (container: Container, config: IConfiguration) {
    const configuration = config.byKey<ComponentsStructureConfig>(COMPONENTS_STRUCTURE_CONFIG)

    const graph = container.get<IGraphQL>(GraphQlConnectorType)
    graph.useMiddlewares(container.get(AuthGraphQLMiddlewareType))
    graph.useQueries(orderQueries(config))

    // Create profile tabs
    const profileTabsService = container.get<IProfileTabsService | undefined>(ProfileTabsServiceType)
    if (profileTabsService) {
      profileTabsService.addTab(pickTabItemsFactory(configuration, TabOption.Orders))
    } else {
      logger('[OrdersModule]: There\'s no ProfileTabsService available', 'debug')
    }

    // Define available order statuses
    const orderStatusesService = container.get<IOrderStatusesService | undefined>(OrderStatusesServiceType)
    if (orderStatusesService && configuration) {
      orderStatusesService.addStatuses(configuration)
    } else {
      logger(`[OrdersModule] There's no OrderStatusesService available. Typeof required configuration: ${configuration}!`, 'debug')
    }
  },
  routes,
  state
})

export class OrdersModule extends Module {}
